export const environment = {
  baseAPI: 'https://securepay-backend-dev.getsecurepay.ai',
  production: false,
  checkoutFrontendUrl: 'http://localhost:4203/',
};
